import { useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

export const usePendingUsers = () => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [pendingTotal, setPendingTotal] = useState(0);
  const [pendingPage, setPendingPage] = useState(1);
  const [pendingTotalPages, setPendingTotalPages] = useState(1);

  const fetchPendingUsers = async (page = pendingPage) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/users/pending?page=${page}&per_page=50`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Paginated payload; older builds returned a bare array.
      setPendingUsers(response.data.users || response.data || []);
      setPendingTotal(response.data.total ?? (response.data.length || 0));
      setPendingPage(response.data.page ?? page);
      setPendingTotalPages(response.data.total_pages ?? 1);
    } catch (error) {
      toast.error('Failed to load pending users');
    }
  };

  const deletePendingUser = async (userId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/admin/users/pending/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Pending user deleted');
      fetchPendingUsers();
    } catch (error) {
      toast.error('Failed to delete pending user');
    }
  };

  return {
    pendingUsers,
    pendingTotal,
    pendingPage,
    pendingTotalPages,
    setPendingPage,
    fetchPendingUsers,
    deletePendingUser
  };
};

export default usePendingUsers;
